import BootstrapTooltip from "bootstrap/js/dist/tooltip";
import { useEffect, useRef } from "react";

function Tooltip({
  children,
  offset,
  placement = "top",
  text,
  trigger = "hover focus",
}) {
  const targetRef = useRef(null);

  useEffect(() => {
    if (!targetRef.current || !text) {
      return undefined;
    }

    const tooltip = new BootstrapTooltip(targetRef.current, {
      offset,
    });
    return () => tooltip.dispose();
  }, [offset, text]);

  if (!text) {
    return children;
  }

  return (
    <span
      ref={targetRef}
      data-bs-placement={placement}
      data-bs-title={text}
      data-bs-toggle="tooltip"
      data-bs-trigger={trigger}
    >
      {children}
    </span>
  );
}

export default Tooltip;
